$(document).ready(function(){

  equalheight = function(container){

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    $(container).each(function() {

      $el = $(this);
      $($el).height('auto')
      topPostion = $el.position().top;

      if (currentRowStart != topPostion) {
        for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPostion;
        currentTallest = $el.height();
        rowDivs.push($el);
      } else {
        rowDivs.push($el);
        currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
      }
      for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
    });
  }

  $(window).load(function() {
    equalheight('.hup-prod-list .grid__item');
  });

  $(document).ajaxComplete(function( event, request, settings ){
    equalheight('.hup-prod-list .grid__item');
  });

  $(window).resize(function(){
    equalheight('.hup-prod-list .grid__item');
  });

  jQuery('.js-qty__adjust').on('click', function() {
    var el = $(this),
        id = el.data('id'),
        qtySelector = el.siblings('.js-qty__num'),
        qty = parseInt(qtySelector.val().replace(/\D/g, ''));

    var qty = validateQty(qty);

    // Add or subtract from the current quantity
    if (el.hasClass('js-qty__adjust--plus')) {
      qty = qty + 1;
    } else {
      qty = qty - 1;
      if (qty <= 1) qty = 1;
    }

    // Update the input's number
    qtySelector.val(qty);
  });
  validateQty = function (qty) {
  if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};
  
 /* $('#hup_img_slider').owlCarousel({
    items:1,
    loop:true,
    margin:0,
    nav:true,
    navText:["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
    dots:false,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true
  });*/

 /* $('#home_collection_slider').owlCarousel({
    loop:true,
    responsiveClass:true,
    nav:true,
    navText:["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
    dots:true,
    responsive:{
      0:{
        items:1
      },
      450:{
        items:1
      },
      520:{
        items:2,
        margin:30,
        loop:false
      },
      768:{
        items:3,
        margin:30,
        stagePadding: 80,
        dots:true,
        nav:true
      }
    }
  });*/
});